<template>
  <div>
    <!-- 筛选框 -->
    <transition name="el-zoom-in-top">
      <div class="search" v-if="searchDesc && isShowSearch">
        <!-- searchData -->
        <ele-form
          :isShowBackBtn="false"
          :isShowResetBtn="true"
          inline
          :form-attrs="{
            size: 'small'
          }"
          submitBtnText="搜索"
          v-model="searchData"
          :form-desc="searchDesc"
          @reset="searchReset"
          :request-fn="searchSubmit"
          @request-success="searchSuccess"
        ></ele-form>
      </div>
    </transition>
    <!-- 表格头部按钮 -->
    <div class="btn-nav">
      <!-- left按钮 -->
      <div class="btn-nav-left">
        <!-- 添加按钮 -->
        <el-button
          type="success"
          size="small"
          v-show="option.addBtn || 'undefined' === typeof option.addBtn"
          @click="addBtn"
          >添加</el-button
        >
        <!--  -->
        <!-- 自定义按钮 -->
        <template v-for="(item, index) in option.btnNavLeft">
          <el-button
            :key="index"
            @click="item.click && item.click(option)"
            :size="item.size"
            :type="item.type"
            :icon="item.icon"
            >{{ item.text }}</el-button
          >
        </template>
      </div>
      <!-- right按钮 -->
      <div class="btn-nav-right">
        <!-- 筛选 -->
        <el-tooltip content="筛选" placement="top">
          <el-button
            @click="searchBtn"
            v-show="searchDesc"
            size="mini"
            icon="el-icon-search"
          ></el-button>
        </el-tooltip>
        <!-- <el-tooltip content="Top center" placement="top"></el-tooltip> -->
        <!-- 刷新   -->
        <el-tooltip content="刷新" placement="top">
          <el-button
            @click="refreshBtn"
            v-show="
              option.refreshBtn || 'undefined' === typeof option.refreshBtn
            "
            size="mini"
            icon="el-icon-refresh"
          ></el-button>
        </el-tooltip>
        <!-- 导出 -->
        <!-- el-icon-download -->
        <el-tooltip content="导出" placement="top">
          <el-button
            v-show="option.exportBtn"
            size="mini"
            icon="el-icon-download"
            @click="exportData"
          ></el-button>
        </el-tooltip>
        <!-- 自定义按钮 -->
        <template v-for="(item, index) in option.btnNavRight">
          <el-button
            :key="index"
            @click="item.click && item.click(option)"
            :size="item.size"
            :type="item.type"
            :icon="item.icon"
            >{{ item.text }}</el-button
          >
        </template>

        <el-popover
          v-show="option.hideBtn"
          placement="bottom-end"
          width="150"
          trigger="click"
        >
          <template v-for="(item, field) in option.column">
            <el-checkbox :key="field" :label="item.label" v-model="item.hide">{{
              item.label
            }}</el-checkbox>
          </template>
          <el-button icon="el-icon-s-grid" slot="reference"></el-button>
        </el-popover>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      :show-overflow-tooltip="true"
      :row-key="option.rowKey"
      :default-expand-all="option.defaultExpandAll"
      :data="tableData"
      style="width: 100%"
      :highlight-current-row="option.current"
      :height="option.height"
      :stripe="option.stripe"
      @current-change="currentChange"
      @selection-change="handleSelectionChange"
      :border="option.border"
    >
      <!-- 多选 -->
      <template v-if="option.selection">
        <el-table-column type="selection" width="55"></el-table-column>
      </template>
      <!-- 折叠框 -->
      <template v-if="option.expand">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-position="left" inline class="demo-table-expand">
              <template v-for="(item, index) in option.column">
                <div :key="index" :style="option.expandStyle">
                  <!-- 标签 -->
                  <el-form-item v-if="item.show == 'tag'" :label="item.label">
                    <div class="name-wrapper" v-if="item.tagtype">
                      <el-tag
                        v-for="(tag, inde) in item.tagtype"
                        :key="inde"
                        :size="tag.size"
                        :type="tag.type"
                        v-show="
                          tagIsShow(
                            scope.row[item.prop],
                            tag.value,
                            tag.regular
                          )
                        "
                        >{{ tag.text }}</el-tag
                      >
                    </div>
                    <div class="name-wrapper" v-else>
                      <el-tag
                        :size="item.tagSize || 'medium'"
                        :type="item.tagType || ''"
                        >{{ scope.row[item.prop] }}</el-tag
                      >
                    </div>
                  </el-form-item>
                  <!-- 图片 -->
                  <el-form-item
                    v-else-if="item.show == 'image'"
                    :label="item.label"
                  >
                    <el-image
                      class="table-image"
                      style="width: 70px; height: 70px;"
                      @click="test(scope)"
                      :src="scope.row[item.prop]"
                      :preview-src-list="[scope.row[item.prop]]"
                      fit="cover"
                    >
                      <div slot="placeholder" class="image-slot">
                        加载中
                        <span class="dot">...</span>
                      </div>
                    </el-image>
                  </el-form-item>
                  <!-- 文字 -->
                  <el-form-item v-else :label="item.label">
                    <span @click="test(scope)" v-if="item.childrenProp">{{
                      scope.row[item.prop][item.childrenProp]
                    }}</span>
                    <span @click="test(scope)" v-else>{{
                      scope.row[item.prop]
                    }}</span>
                  </el-form-item>
                </div>
              </template>
              <div v-if="option.expandBtn">
                <el-button
                  v-for="(item, index) in option.expandBtn"
                  :key="index"
                  @click="
                    item.click &&
                      item.click(scope.row.id, scope.row, scope.$index)
                  "
                  v-show="item.Vif ? item.Vif(scope.row) : true"
                  :size="item.size"
                  :type="item.type"
                  :icon="item.icon"
                  >{{ item.text }}</el-button
                >
              </div>
            </el-form>
          </template>
        </el-table-column>
      </template>
      <!-- 索引 -->
      <el-table-column
        v-if="option.index || 'undefined' === typeof option.index"
        type="index"
        :index="indexMethod"
        label="#"
      ></el-table-column>
      <!-- 表格数据 -->
      <template v-for="(item, index) in option.column">
        <template v-if="item.hide || 'undefined' === typeof item.hide">
          <!-- 图片显示 -->
          <template v-if="item.show == 'image'">
            <el-table-column
              :key="index"
              :sortable="item.sortable"
              :prop="item.prop"
              :label="item.label"
            >
              <template slot-scope="scope">
                <el-image
                  class="table-image"
                  style="width: 50px; height: 50px;"
                  @click="test(scope)"
                  :src="scope.row[item.prop]"
                  :preview-src-list="[scope.row[item.prop]]"
                  fit="cover"
                >
                  <div slot="placeholder" class="image-slot">
                    加载中
                    <span class="dot">...</span>
                  </div>
                </el-image>
              </template>
            </el-table-column>
          </template>
          <!-- 标签 -->
          <template v-else-if="item.show == 'tag'">
            <el-table-column
              :key="index"
              :sortable="item.sortable"
              :prop="item.prop"
              :width="item.width ? item.width : ''"
              :label="item.label"
            >
              <template slot-scope="scope">
                <div class="name-wrapper" v-if="item.tagtype">
                  <el-tag
                    :disable-transitions="true"
                    v-for="(tag, inde) in item.tagtype"
                    :key="inde"
                    :size="tag.size"
                    :type="tag.type"
                    v-show="
                      tagIsShow(scope.row[item.prop], tag.value, tag.regular)
                    "
                    >{{ tag.text }}</el-tag
                  >
                </div>
                <div class="name-wrapper" v-else>
                  <el-tag
                    :size="item.tagSize || 'medium'"
                    :type="item.tagType || ''"
                    >{{ scope.row[item.prop] }}</el-tag
                  >
                </div>
              </template>
            </el-table-column>
          </template>
          <!-- 输入框 -->
          <template v-else-if="item.show == 'input'">
            <el-table-column
              :key="index"
              :sortable="item.sortable"
              :prop="item.prop"
              :label="item.label"
            >
              <template slot-scope="scope">
                <el-input
                  @change="blurChange(scope.row)"
                  v-model="scope.row[item.prop]"
                ></el-input>
              </template>
            </el-table-column>
          </template>
          <!-- 输入框 -->
          <template v-else-if="item.show == 'number'">
            <el-table-column
              :key="index"
              :sortable="item.sortable"
              :prop="item.prop"
              :label="item.label"
            >
              <template slot-scope="scope">
                <el-input-number
                  @change="blurChange(scope.row)"
                  :precision="2"
                  :controls="false"
                  :style="scope.row.style ? scope.row.style : 'width:120px;'"
                  :min="0"
                  v-model="scope.row[item.prop]"
                ></el-input-number>
              </template>
            </el-table-column>
          </template>
          <!-- 下拉框 -->
          <template v-else-if="item.show == 'select'">
            <el-table-column
              :key="index"
              :sortable="item.sortable"
              :prop="item.prop"
              :label="item.label"
            >
              <template slot-scope="scope">
                <el-select
                  @change="blurChange(scope.row)"
                  v-model="scope.row[item.prop]"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(ite, inde) in item.selectDataList"
                    :key="inde"
                    :label="ite.label"
                    :value="ite.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          </template>
          <!-- 状态 -->
          <template v-else-if="item.show == 'checkbox'">
            <el-table-column
              :key="index"
              :sortable="item.sortable"
              :prop="item.prop"
              :width="item.width ? item.width : ''"
              :label="item.label"
            >
              <template slot-scope="scope">
                <el-checkbox
                  @change="blurChange(scope.row)"
                  v-model="scope.row[item.prop]"
                ></el-checkbox>
              </template>
            </el-table-column>
          </template>
          <!-- 超链接 -->
          <template v-else-if="item.show == 'hyperlinks'">
            <el-table-column
              :key="index"
              :sortable="item.sortable"
              :prop="item.prop"
              :width="item.width ? item.width : ''"
              :label="item.label"
            >
              <template slot-scope="scope">
                <el-link
                  @click="
                    item.click &&
                      item.click(scope.row.id, scope.row, scope.$index)
                  "
                  :type="item.type || ''"
                  class="text-style"
                  >{{ scope.row[item.prop] }}</el-link
                >
              </template>
            </el-table-column>
          </template>
          <!-- 按钮 -->
          <template v-else-if="item.show == 'button'">
            <el-table-column
              :key="index"
              :sortable="item.sortable"
              :prop="item.prop"
              :width="item.width ? item.width : ''"
              :label="item.label"
            >
              <template slot-scope="scope">
                <el-button
                  @click="
                    item.click &&
                      item.click(scope.row.id, scope.row, scope.$index)
                  "
                  :size="item.size"
                  :type="item.type || 'text'"
                  :icon="item.icon || ''"
                  class="text-style"
                  >{{ scope.row[item.prop] }}</el-button
                >
              </template>
            </el-table-column>
          </template>
          <!-- 文字显示 -->
          <template v-else>
            <template v-if="item.nowrap">
              <el-table-column
                :key="index"
                :sortable="item.sortable"
                :prop="item.prop"
                :width="item.width ? item.width : ''"
                :label="item.label"
              >
                <template slot-scope="scope">
                  <el-tooltip :content="scope.row[item.prop]" placement="top">
                    <div class="text-style">{{ scope.row[item.prop] }}</div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </template>
            <template v-else>
              <el-table-column
                :key="index"
                :sortable="item.sortable"
                :prop="item.prop"
                :width="item.width ? item.width : ''"
                :label="item.label"
              />
            </template>
          </template>
        </template>
        <!-- 普通类型显示 -->
      </template>
      <!-- v-show = "typeof option.btnList||option.editBtn||option.delBtn" -->
      <!-- 操作栏 提供 编辑 删除-->
      <el-table-column
        :fixed="option.fixed"
        label="操作"
        v-if="option.btnList || option.editBtn || option.delBtn"
      >
        <template slot-scope="scope">
          <el-button
            v-show="option.editBtn || 'undefined' === typeof option.editBtn"
            @click="editBtn(scope.row.id, scope.row, scope.$index)"
            type="text"
            size="small"
            >编辑</el-button
          >
          <el-button
            v-show="option.delBtn || 'undefined' === typeof option.delBtn"
            @click="delBtn(scope.row.id, scope.row, scope.$index)"
            slot="reference"
            type="text"
            size="small"
            >删除</el-button
          >
          <!-- 自定义操作栏 按钮-->
          <!-- v-show="(item.Vif && item.Vif(scope.row))" -->
          <el-button
            v-for="(item, index) in option.btnList"
            @click="
              item.click && item.click(scope.row.id, scope.row, scope.$index)
            "
            v-show="item.Vif ? item.Vif(scope.row) : true"
            :Key="index"
            :type="item.type"
            :size="item.size ? item.size : 'mini'"
            >{{ item.name }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pagerCount"
        background
        :page-sizes="page.pageSizes"
        :page-size="page.pageSize"
        :layout="page.layout"
        :total="page.total"
      ></el-pagination>
    </div>
    <!-- 表格底部按钮 -->
    <div class="btn-bottom" v-show="option.btnBottom">
      <el-button @click="submitColumnList">提交</el-button>
    </div>
    <!-- 表单 -->
    <div class="from">
      <ele-form-dialog
        v-model="formData"
        :formDesc="formDesc"
        :request-fn="handleSubmit"
        :rules="rules"
        labelPosition="left"
        :form-attrs="{ size: 'small' }"
        :dialogAttrs="{
          center: false,
          'destroy-on-close': true,
          'custom-class': 'formD'
        }"
        :visible.sync="dialogFormVisible"
        @request-success="handleSuccess"
        :title="formTitle"
      ></ele-form-dialog>
    </div>
  </div>
</template>

<script>
import { export2Excel } from "@/common/js/util.js";

export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    searchDesc: {
      type: Object,
      default: function() {
        return null;
      }
    },
    option: {
      type: Object,
      default: function() {
        return {};
      }
    },
    page: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      optionData: this.option,
      // select:"",
      searchData: {},
      formData: {},
      formDesc: {},
      onlyId: this.option.onlyId,
      rules: {},
      visible: false,
      dialogFormVisible: false,
      submitType: -1,
      formTitle: this.option.title,
      isShowSearch: this.option.searchBtn,
      url:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      // url:'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171j.jpeg',
      rowList: [],
      addformDesc: {},
      editformDesc: {}
    };
  },
  created() {
    // this.formDesclist()
    this.formDesclist(this.optionData.column);
    // this.searchDescLsit(this.optionData.column)
  },
  mounted() {},
  methods: {
    // 导出
    exportData() {
      this.$prompt("请输文件名", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // inputPattern: /\s/,
        inputValue: this.option.title ? this.option.title + "表" : "数据类表",
        inputErrorMessage: "不能为空"
      })
        .then(({ value }) => {
          this.$message({
            type: "success",
            message: "文件" + value + "下载中...."
          });
          let columnsList = [];
          // 处理表头
          let array = this.option.column;
          for (let i = 0; i < array.length; i++) {
            // 筛选不导出的表头数据
            if (
              array[i].exportcolumns ||
              "undefined" === typeof array[i].exportcolumns
            ) {
              columnsList.push({
                title: array[i].label,
                key: array[i].prop
              });
            }
          }
          export2Excel(columnsList, this.tableData, value);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消下载"
          });
        });
    },
    // 表单底部提价按钮
    submitColumnList() {
      this.$confirm("此操作将修改数据,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$emit("searchSubmit", this.rowList);
        })
        .catch(() => {});
    },
    // 表单输入框失去焦点
    blurChange(row) {
      let rowList = this.rowList;
      if (rowList.length == 0) {
        rowList.push(row);
        return;
      }
      let flg = (() => {
        for (let i = 0; i < rowList.length; i++) {
          if (rowList[i][this.onlyId] == row[this.onlyId]) {
            return i + "";
          }
        }
        return false;
      })();
      if (flg) {
        rowList[+flg] = row;
      } else {
        rowList.push(row);
      }
      this.rowList = rowList;
      // blurChange
    },
    tagIsShow(pos, val) {
      if (pos == val) return true;
      // let patt1=new RegExp(regular);
      // if(regular){
      // 	return patt1.test(pos);
      // }else{
      // 	if(pos==val) return true;
      // }
    },
    test(e) {},
    // 筛选表单格式
    // searchDescLsit(e){
    // 		let data = e
    // 		let searchDescData = {}
    // 		for(let i = 0;i<data.length;i++){
    // 			if(data[i].searchDisplay){
    // 				let text  = data[i].prop
    // 				searchDescData[text] = data[i]
    // 				searchDescData[text]["layout"] = 6
    // 				searchDescData[text]["required"] = false
    // 			}

    // 	}
    // 	return searchDescData;
    // 	this.searchDesc = searchDescData
    // },
    // 删选表单
    searchReset(a) {
      this.$emit("searchSubmit", false);
    },
    // 重置表单提交
    searchSubmit(data) {
      var arr = Object.keys(data);
      if (arr.length == 0) {
        this.$emit("searchSubmit", false);
      } else {
        this.$emit("searchSubmit", data);
      }
    },
    // 筛选表单提交成功
    searchSuccess() {},
    // 增加/编辑表单格式
    formDesclist(e) {
      let data = e;
      let addData = {};
      let editData = {};
      for (let i = 0; i < data.length; i++) {
        let text = data[i].prop;
        if (data[i].addDisplay || "undefined" === typeof data[i].addDisplay) {
          addData[text] = data[i];
        }
        if (data[i].editDisplay || "undefined" === typeof data[i].editDisplay) {
          editData[text] = data[i];
        }
        // if(data[i].propData){
        // 	addData[text].prop = data[i].propData
        // 	editData[text].prop= data[i].propData

        // }
      }
      this.addformDesc = addData;
      this.editformDesc = editData;
    },
    // 单选
    currentChange(e) {
      this.$emit("currentChange", e);
    },
    // 多选
    handleSelectionChange(e) {
      this.$emit("handleSelectionChange", e);
    },
    // 提交
    handleSubmit(data) {
      // eslint-disable-next-line no-console
      if (this.submitType == 0) {
        this.$emit("addSubmit", data);
      } else if (this.submitType == 1) {
        this.$emit("etidSubmit", data);
      }

      return Promise.resolve();
    },
    // 提交成功
    handleSuccess() {
      this.dialogFormVisible = false;
    },
    // 添加按钮
    addBtn() {
      this.formTitle = this.option.title ? "添加" + this.option.title : "添加";
      this.formData = {};
      this.formDesc = this.addformDesc;
      this.submitType = 0;
      this.dialogFormVisible = true;
    },
    // 编辑
    editBtn(id, row, index) {
      this.formTitle = this.option.title ? "编辑" + this.option.title : "编辑";
      this.formDesc = this.editformDesc;
      this.submitType = 1;
      this.formData = row;
      this.dialogFormVisible = true;
    },
    // 删除
    delBtn(id, row, index) {
      this.visible = false;
      this.$emit("delBtn", row);
    },
    // 索引
    indexMethod(index) {
      return index + 1;
    },
    // 刷新
    refreshBtn() {
      this.$emit("refreshBtn", new Date());
    },
    // 搜索显示框
    searchBtn() {
      this.isShowSearch = !this.isShowSearch;
    },
    handleClick(row) {},
    handleSizeChange(e) {
      let page = this.page;
      page.pageSize = e;
      this.$emit("refresh-change", page);
    },
    handleCurrentChange(e) {
      // this.$emit("refresh-change");
      let page = this.page;
      page.currentPage = e;
      this.$emit("refresh-change", page);
    }
  }
};
</script>

<style lang="scss" scoped>
.text-style {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.paging {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
}
.demo-table-expand {
  display: inline;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.btn-bottom {
  // z-index: 9999;

  display: flex;
  justify-content: center;
  padding: 5px 0;
  background-color: #f2f6fc;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  bottom: 0;
}
// .search{
// }
.btn-nav {
  width: 100%;
  display: flex;

  .btn-nav-left {
    display: flex;
    width: 50%;
  }

  .btn-nav-right {
    display: flex;
    justify-content: flex-end;
    width: 50%;
    el-button {
      margin: 0;
    }
    .right-icon {
      border: 1px solid #dcdfe6;

      i {
        font-size: 30px;
      }
    }
  }
}
.table-image {
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  // style="width: 80px; height: auto;"
}
</style>
